// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from "./core/CancelablePromise"
import { OpenAPI } from "./core/OpenAPI"
import { request as __request } from "./core/request"
import type {
  ActivateUserApiV1AdminUsersUserIdActivatePostData,
  ActivateUserApiV1AdminUsersUserIdActivatePostResponse,
  AssignRoleToUserApiV1AdminUsersUserIdRolesPostData,
  AssignRoleToUserApiV1AdminUsersUserIdRolesPostResponse,
  ChangePasswordApiV1UsersMeChangePasswordPostData,
  ChangePasswordApiV1UsersMeChangePasswordPostResponse,
  CheckPasswordStrengthApiV1AuthPasswordCheckStrengthPostData,
  CheckPasswordStrengthApiV1AuthPasswordCheckStrengthPostResponse,
  ConfirmPasswordResetApiV1AuthPasswordResetConfirmPostData,
  ConfirmPasswordResetApiV1AuthPasswordResetConfirmPostResponse,
  CreateAttendanceApiV1AttendancesPostData,
  CreateAttendanceApiV1AttendancesPostResponse,
  CreateClassSessionApiV1ClassSessionsPostData,
  CreateClassSessionApiV1ClassSessionsPostResponse,
  CreateClassTemplateApiV1ClassTemplatesPostData,
  CreateClassTemplateApiV1ClassTemplatesPostResponse,
  CreateEnrollmentApiV1EnrollmentsPostData,
  CreateEnrollmentApiV1EnrollmentsPostResponse,
  CreateHouseholdApiV1HouseholdsPostData,
  CreateHouseholdApiV1HouseholdsPostResponse,
  CreatePermissionApiV1AdminPermissionsPostData,
  CreatePermissionApiV1AdminPermissionsPostResponse,
  CreateRoleApiV1AdminRolesPostData,
  CreateRoleApiV1AdminRolesPostResponse,
  CreateSessionApiV1SessionsPostData,
  CreateSessionApiV1SessionsPostResponse,
  CreateStudentApiV1StudentsPostData,
  CreateStudentApiV1StudentsPostResponse,
  CreateUserApiV1AdminUsersPostData,
  CreateUserApiV1AdminUsersPostResponse,
  DeactivateCurrentUserApiV1UsersMeDeactivatePostResponse,
  DeactivateUserApiV1AdminUsersUserIdDeactivatePostData,
  DeactivateUserApiV1AdminUsersUserIdDeactivatePostResponse,
  DeleteAttendanceApiV1AttendancesAttendanceIdDeleteData,
  DeleteAttendanceApiV1AttendancesAttendanceIdDeleteResponse,
  DeleteAvatarApiV1UsersMeAvatarDeleteResponse,
  DeleteClassSessionApiV1ClassSessionsClassSessionIdDeleteData,
  DeleteClassSessionApiV1ClassSessionsClassSessionIdDeleteResponse,
  DeleteClassTemplateApiV1ClassTemplatesClassTemplateIdDeleteData,
  DeleteClassTemplateApiV1ClassTemplatesClassTemplateIdDeleteResponse,
  DeleteCoverPhotoApiV1UsersMeCoverPhotoDeleteResponse,
  DeleteEnrollmentApiV1EnrollmentsEnrollmentIdDeleteData,
  DeleteEnrollmentApiV1EnrollmentsEnrollmentIdDeleteResponse,
  DeleteFileApiV1FilesFileIdDeleteData,
  DeleteFileApiV1FilesFileIdDeleteResponse,
  DeleteHouseholdApiV1HouseholdsHouseholdIdDeleteData,
  DeleteHouseholdApiV1HouseholdsHouseholdIdDeleteResponse,
  DeleteRoleApiV1AdminRolesRoleIdDeleteData,
  DeleteRoleApiV1AdminRolesRoleIdDeleteResponse,
  DeleteSessionApiV1SessionsSessionIdDeleteData,
  DeleteSessionApiV1SessionsSessionIdDeleteResponse,
  DeleteStudentApiV1StudentsStudentIdDeleteData,
  DeleteStudentApiV1StudentsStudentIdDeleteResponse,
  DeleteUserApiV1AdminUsersUserIdDeleteData,
  DeleteUserApiV1AdminUsersUserIdDeleteResponse,
  DownloadFileApiV1FilesFileIdDownloadGetData,
  DownloadFileApiV1FilesFileIdDownloadGetResponse,
  GenerateClassTemplateMeetingsApiV1ClassTemplatesClassTemplateIdGenerateMeetingsPostData,
  GenerateClassTemplateMeetingsApiV1ClassTemplatesClassTemplateIdGenerateMeetingsPostResponse,
  GetCurrentUserApiV1AuthMeGetResponse,
  GetCurrentUserApiV1UsersMeGetResponse,
  GetFileInfoApiV1FilesFileIdGetData,
  GetFileInfoApiV1FilesFileIdGetResponse,
  GetFutureClassSessionsCountApiV1ClassSessionsFutureCountGetData,
  GetFutureClassSessionsCountApiV1ClassSessionsFutureCountGetResponse,
  GetInvoiceApiV1InvoicesInvoiceIdGetData,
  GetInvoiceApiV1InvoicesInvoiceIdGetResponse,
  GetPublicProfileApiV1ProfilesUsernameGetData,
  GetPublicProfileApiV1ProfilesUsernameGetResponse,
  GetPublicProfileByIdApiV1ProfilesIdUserIdGetData,
  GetPublicProfileByIdApiV1ProfilesIdUserIdGetResponse,
  GetRoleApiV1AdminRolesRoleIdGetData,
  GetRoleApiV1AdminRolesRoleIdGetResponse,
  GetSystemLimitsApiV1SystemLimitsGetResponse,
  GetUserApiV1AdminUsersUserIdGetData,
  GetUserApiV1AdminUsersUserIdGetResponse,
  GetUserPermissionsApiV1AdminUsersUserIdPermissionsGetData,
  GetUserPermissionsApiV1AdminUsersUserIdPermissionsGetResponse,
  GetUserRolesApiV1AdminUsersUserIdRolesGetData,
  GetUserRolesApiV1AdminUsersUserIdRolesGetResponse,
  HealthHealthGetResponse,
  ListFilesApiV1FilesGetData,
  ListFilesApiV1FilesGetResponse,
  ListInvoicesApiV1InvoicesGetData,
  ListInvoicesApiV1InvoicesGetResponse,
  ListPermissionsApiV1AdminPermissionsGetData,
  ListPermissionsApiV1AdminPermissionsGetResponse,
  ListRolesApiV1AdminRolesGetData,
  ListRolesApiV1AdminRolesGetResponse,
  ListUsersApiV1AdminUsersGetData,
  ListUsersApiV1AdminUsersGetResponse,
  ListUsersWithRolesApiV1AdminUsersWithRolesGetData,
  ListUsersWithRolesApiV1AdminUsersWithRolesGetResponse,
  LivenessHealthLiveGetResponse,
  LoginApiV1AuthLoginPostData,
  LoginApiV1AuthLoginPostResponse,
  LogoutApiV1AuthLogoutPostResponse,
  PerformanceMetricsHealthPerformanceGetResponse,
  ReadAttendanceApiV1AttendancesAttendanceIdGetData,
  ReadAttendanceApiV1AttendancesAttendanceIdGetResponse,
  ReadAttendancesApiV1AttendancesGetData,
  ReadAttendancesApiV1AttendancesGetResponse,
  ReadClassSessionApiV1ClassSessionsClassSessionIdGetData,
  ReadClassSessionApiV1ClassSessionsClassSessionIdGetResponse,
  ReadClassSessionsApiV1ClassSessionsGetData,
  ReadClassSessionsApiV1ClassSessionsGetResponse,
  ReadClassTemplateApiV1ClassTemplatesClassTemplateIdGetData,
  ReadClassTemplateApiV1ClassTemplatesClassTemplateIdGetResponse,
  ReadClassTemplatesApiV1ClassTemplatesGetData,
  ReadClassTemplatesApiV1ClassTemplatesGetResponse,
  ReadEnrollmentApiV1EnrollmentsEnrollmentIdGetData,
  ReadEnrollmentApiV1EnrollmentsEnrollmentIdGetResponse,
  ReadEnrollmentsApiV1EnrollmentsGetData,
  ReadEnrollmentsApiV1EnrollmentsGetResponse,
  ReadHouseholdApiV1HouseholdsHouseholdIdGetData,
  ReadHouseholdApiV1HouseholdsHouseholdIdGetResponse,
  ReadHouseholdMeApiV1HouseholdsMeGetResponse,
  ReadHouseholdsApiV1HouseholdsGetData,
  ReadHouseholdsApiV1HouseholdsGetResponse,
  ReadSessionApiV1SessionsSessionIdGetData,
  ReadSessionApiV1SessionsSessionIdGetResponse,
  ReadSessionsApiV1SessionsGetData,
  ReadSessionsApiV1SessionsGetResponse,
  ReadStudentApiV1StudentsStudentIdGetData,
  ReadStudentApiV1StudentsStudentIdGetResponse,
  ReadStudentsApiV1StudentsGetData,
  ReadStudentsApiV1StudentsGetResponse,
  ReadinessHealthReadyGetResponse,
  RecordWebVitalsApiV1MonitoringWebVitalsPostData,
  RecordWebVitalsApiV1MonitoringWebVitalsPostResponse,
  RefreshTokenApiV1AuthRefreshPostData,
  RefreshTokenApiV1AuthRefreshPostResponse,
  RegisterApiV1AuthRegisterPostData,
  RegisterApiV1AuthRegisterPostResponse,
  RemoveRoleFromUserApiV1AdminUsersUserIdRolesRoleIdDeleteData,
  RemoveRoleFromUserApiV1AdminUsersUserIdRolesRoleIdDeleteResponse,
  RequestPasswordResetApiV1AuthPasswordResetPostData,
  RequestPasswordResetApiV1AuthPasswordResetPostResponse,
  ResendVerificationEmailApiV1AuthResendVerificationPostData,
  ResendVerificationEmailApiV1AuthResendVerificationPostResponse,
  SendBulkEmailApiV1CommunicationsBulkEmailPostData,
  SendBulkEmailApiV1CommunicationsBulkEmailPostResponse,
  SetFilePublicApiV1FilesFileIdSetPublicPostData,
  SetFilePublicApiV1FilesFileIdSetPublicPostResponse,
  UpdateAttendanceApiV1AttendancesAttendanceIdPutData,
  UpdateAttendanceApiV1AttendancesAttendanceIdPutResponse,
  UpdateClassSessionApiV1ClassSessionsClassSessionIdPutData,
  UpdateClassSessionApiV1ClassSessionsClassSessionIdPutResponse,
  UpdateClassTemplateApiV1ClassTemplatesClassTemplateIdPutData,
  UpdateClassTemplateApiV1ClassTemplatesClassTemplateIdPutResponse,
  UpdateCurrentUserApiV1UsersMePutData,
  UpdateCurrentUserApiV1UsersMePutResponse,
  UpdateEnrollmentApiV1EnrollmentsEnrollmentIdPutData,
  UpdateEnrollmentApiV1EnrollmentsEnrollmentIdPutResponse,
  UpdateHouseholdApiV1HouseholdsHouseholdIdPutData,
  UpdateHouseholdApiV1HouseholdsHouseholdIdPutResponse,
  UpdateInvoiceApiV1InvoicesInvoiceIdPutData,
  UpdateInvoiceApiV1InvoicesInvoiceIdPutResponse,
  UpdateProfileApiV1UsersMeProfilePutData,
  UpdateProfileApiV1UsersMeProfilePutResponse,
  UpdateRoleApiV1AdminRolesRoleIdPutData,
  UpdateRoleApiV1AdminRolesRoleIdPutResponse,
  UpdateSessionApiV1SessionsSessionIdPutData,
  UpdateSessionApiV1SessionsSessionIdPutResponse,
  UpdateStudentApiV1StudentsStudentIdPutData,
  UpdateStudentApiV1StudentsStudentIdPutResponse,
  UpdateUserApiV1AdminUsersUserIdPutData,
  UpdateUserApiV1AdminUsersUserIdPutResponse,
  UploadAvatarApiV1UsersMeAvatarPostData,
  UploadAvatarApiV1UsersMeAvatarPostResponse,
  UploadCoverPhotoApiV1UsersMeCoverPhotoPostData,
  UploadCoverPhotoApiV1UsersMeCoverPhotoPostResponse,
  UploadFileApiV1FilesUploadPostData,
  UploadFileApiV1FilesUploadPostResponse,
  VerifyEmailApiV1AuthVerifyEmailPostData,
  VerifyEmailApiV1AuthVerifyEmailPostResponse,
} from "./types.gen"

export class AdminService {
  /**
   * List Roles
   * List all roles in the system with optimized permission loading.
   * @param data The data for the request.
   * @param data.includePermissions Include permissions in response
   * @returns StandardResponse_list_RoleResponse__ Roles retrieved successfully
   * @throws ApiError
   */
  public static listRolesApiV1AdminRolesGet(
    data: ListRolesApiV1AdminRolesGetData = {},
  ): CancelablePromise<ListRolesApiV1AdminRolesGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/admin/roles",
      query: {
        include_permissions: data.includePermissions,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Create Role
   * Create a new role with specified permissions.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns StandardResponse_RoleResponse_ Role created successfully
   * @throws ApiError
   */
  public static createRoleApiV1AdminRolesPost(
    data: CreateRoleApiV1AdminRolesPostData,
  ): CancelablePromise<CreateRoleApiV1AdminRolesPostResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/admin/roles",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Get Role
   * Get a specific role with its permissions.
   * @param data The data for the request.
   * @param data.roleId
   * @returns StandardResponse_RoleResponse_ Successful Response
   * @throws ApiError
   */
  public static getRoleApiV1AdminRolesRoleIdGet(
    data: GetRoleApiV1AdminRolesRoleIdGetData,
  ): CancelablePromise<GetRoleApiV1AdminRolesRoleIdGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/admin/roles/{role_id}",
      path: {
        role_id: data.roleId,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Update Role
   * Update a role's properties.
   * @param data The data for the request.
   * @param data.roleId
   * @param data.requestBody
   * @returns StandardResponse_RoleResponse_ Successful Response
   * @throws ApiError
   */
  public static updateRoleApiV1AdminRolesRoleIdPut(
    data: UpdateRoleApiV1AdminRolesRoleIdPutData,
  ): CancelablePromise<UpdateRoleApiV1AdminRolesRoleIdPutResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/admin/roles/{role_id}",
      path: {
        role_id: data.roleId,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Delete Role
   * Delete a role (only non-system roles).
   * @param data The data for the request.
   * @param data.roleId
   * @returns StandardResponse_NoneType_ Successful Response
   * @throws ApiError
   */
  public static deleteRoleApiV1AdminRolesRoleIdDelete(
    data: DeleteRoleApiV1AdminRolesRoleIdDeleteData,
  ): CancelablePromise<DeleteRoleApiV1AdminRolesRoleIdDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v1/admin/roles/{role_id}",
      path: {
        role_id: data.roleId,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * List Permissions
   * List all permissions in the system.
   * @param data The data for the request.
   * @param data.resourceType Filter by resource type
   * @returns StandardResponse_list_PermissionResponse__ Permissions retrieved successfully
   * @throws ApiError
   */
  public static listPermissionsApiV1AdminPermissionsGet(
    data: ListPermissionsApiV1AdminPermissionsGetData = {},
  ): CancelablePromise<ListPermissionsApiV1AdminPermissionsGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/admin/permissions",
      query: {
        resource_type: data.resourceType,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Create Permission
   * Create a new permission.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns StandardResponse_PermissionResponse_ Successful Response
   * @throws ApiError
   */
  public static createPermissionApiV1AdminPermissionsPost(
    data: CreatePermissionApiV1AdminPermissionsPostData,
  ): CancelablePromise<CreatePermissionApiV1AdminPermissionsPostResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/admin/permissions",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * List Users
   * Admin: List all users with pagination and filtering.
   *
   * This endpoint provides admin-level access to list all users in the system.
   * It supports filtering by status and searching by email/name.
   * @param data The data for the request.
   * @param data.isActive Filter by active status
   * @param data.search Search by email or name
   * @param data.page
   * @param data.perPage
   * @returns PaginatedResponse_UserResponse_ Admin users list retrieved successfully
   * @throws ApiError
   */
  public static listUsersApiV1AdminUsersGet(
    data: ListUsersApiV1AdminUsersGetData = {},
  ): CancelablePromise<ListUsersApiV1AdminUsersGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/admin/users",
      query: {
        is_active: data.isActive,
        search: data.search,
        page: data.page,
        per_page: data.perPage,
      },
      errors: {
        400: "Bad request",
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Create User
   * Admin: Create a new user.
   *
   * Allows administrators to create users directly without going through
   * the registration flow. The created user will need to verify their email.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns StandardResponse_UserResponse_ Successful Response
   * @throws ApiError
   */
  public static createUserApiV1AdminUsersPost(
    data: CreateUserApiV1AdminUsersPostData,
  ): CancelablePromise<CreateUserApiV1AdminUsersPostResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/admin/users",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * List Users With Roles
   * Admin: List users with their roles and permissions (optimized for RBAC display).
   *
   * This endpoint is optimized to prevent N+1 queries when displaying users
   * with their role and permission information. It loads all related data
   * in batch queries rather than individual requests.
   * @param data The data for the request.
   * @param data.isActive Filter by active status
   * @param data.page
   * @param data.perPage
   * @returns StandardResponse_list_dict__ Admin users list retrieved successfully
   * @throws ApiError
   */
  public static listUsersWithRolesApiV1AdminUsersWithRolesGet(
    data: ListUsersWithRolesApiV1AdminUsersWithRolesGetData = {},
  ): CancelablePromise<ListUsersWithRolesApiV1AdminUsersWithRolesGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/admin/users-with-roles",
      query: {
        is_active: data.isActive,
        page: data.page,
        per_page: data.perPage,
      },
      errors: {
        400: "Bad request",
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Get User
   * Admin: Get any user by ID.
   *
   * Allows administrators to retrieve detailed information about any user in the system.
   * @param data The data for the request.
   * @param data.userId
   * @returns StandardResponse_UserResponse_ Successful Response
   * @throws ApiError
   */
  public static getUserApiV1AdminUsersUserIdGet(
    data: GetUserApiV1AdminUsersUserIdGetData,
  ): CancelablePromise<GetUserApiV1AdminUsersUserIdGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/admin/users/{user_id}",
      path: {
        user_id: data.userId,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Update User
   * Admin: Update any user's information.
   *
   * Allows administrators to update any user's profile, including email and status.
   * This is separate from user self-service updates which have limited scope.
   * @param data The data for the request.
   * @param data.userId
   * @param data.requestBody
   * @returns StandardResponse_UserResponse_ Successful Response
   * @throws ApiError
   */
  public static updateUserApiV1AdminUsersUserIdPut(
    data: UpdateUserApiV1AdminUsersUserIdPutData,
  ): CancelablePromise<UpdateUserApiV1AdminUsersUserIdPutResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/admin/users/{user_id}",
      path: {
        user_id: data.userId,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Delete User
   * Admin: Delete any user.
   *
   * Allows administrators to delete any user account. Includes safety checks
   * to prevent deletion of the last admin user.
   * @param data The data for the request.
   * @param data.userId
   * @returns StandardResponse_NoneType_ Successful Response
   * @throws ApiError
   */
  public static deleteUserApiV1AdminUsersUserIdDelete(
    data: DeleteUserApiV1AdminUsersUserIdDeleteData,
  ): CancelablePromise<DeleteUserApiV1AdminUsersUserIdDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v1/admin/users/{user_id}",
      path: {
        user_id: data.userId,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Activate User
   * Admin: Activate a deactivated user account.
   *
   * Allows administrators to reactivate any deactivated user account.
   * @param data The data for the request.
   * @param data.userId
   * @returns StandardResponse_UserResponse_ Successful Response
   * @throws ApiError
   */
  public static activateUserApiV1AdminUsersUserIdActivatePost(
    data: ActivateUserApiV1AdminUsersUserIdActivatePostData,
  ): CancelablePromise<ActivateUserApiV1AdminUsersUserIdActivatePostResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/admin/users/{user_id}/activate",
      path: {
        user_id: data.userId,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Deactivate User
   * Deactivate a user account (admin-only).
   *
   * Admins can deactivate any user account. Includes safety check
   * to prevent deactivation of the last admin user.
   * @param data The data for the request.
   * @param data.userId
   * @returns StandardResponse_UserResponse_ Successful Response
   * @throws ApiError
   */
  public static deactivateUserApiV1AdminUsersUserIdDeactivatePost(
    data: DeactivateUserApiV1AdminUsersUserIdDeactivatePostData,
  ): CancelablePromise<DeactivateUserApiV1AdminUsersUserIdDeactivatePostResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/admin/users/{user_id}/deactivate",
      path: {
        user_id: data.userId,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Get User Roles
   * Get all roles assigned to a user with assignment details.
   * @param data The data for the request.
   * @param data.userId
   * @returns StandardResponse_list_UserRoleResponse__ Successful Response
   * @throws ApiError
   */
  public static getUserRolesApiV1AdminUsersUserIdRolesGet(
    data: GetUserRolesApiV1AdminUsersUserIdRolesGetData,
  ): CancelablePromise<GetUserRolesApiV1AdminUsersUserIdRolesGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/admin/users/{user_id}/roles",
      path: {
        user_id: data.userId,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Assign Role To User
   * Assign a role to a user.
   * @param data The data for the request.
   * @param data.userId
   * @param data.requestBody
   * @returns StandardResponse_NoneType_ Role assigned to user successfully
   * @throws ApiError
   */
  public static assignRoleToUserApiV1AdminUsersUserIdRolesPost(
    data: AssignRoleToUserApiV1AdminUsersUserIdRolesPostData,
  ): CancelablePromise<AssignRoleToUserApiV1AdminUsersUserIdRolesPostResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/admin/users/{user_id}/roles",
      path: {
        user_id: data.userId,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Get User Permissions
   * Get all effective permissions for a user.
   * @param data The data for the request.
   * @param data.userId
   * @returns StandardResponse_list_str__ Successful Response
   * @throws ApiError
   */
  public static getUserPermissionsApiV1AdminUsersUserIdPermissionsGet(
    data: GetUserPermissionsApiV1AdminUsersUserIdPermissionsGetData,
  ): CancelablePromise<GetUserPermissionsApiV1AdminUsersUserIdPermissionsGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/admin/users/{user_id}/permissions",
      path: {
        user_id: data.userId,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Remove Role From User
   * Remove a role from a user.
   * @param data The data for the request.
   * @param data.userId
   * @param data.roleId
   * @returns StandardResponse_NoneType_ Successful Response
   * @throws ApiError
   */
  public static removeRoleFromUserApiV1AdminUsersUserIdRolesRoleIdDelete(
    data: RemoveRoleFromUserApiV1AdminUsersUserIdRolesRoleIdDeleteData,
  ): CancelablePromise<RemoveRoleFromUserApiV1AdminUsersUserIdRolesRoleIdDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v1/admin/users/{user_id}/roles/{role_id}",
      path: {
        user_id: data.userId,
        role_id: data.roleId,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }
}

export class AttendancesService {
  /**
   * Create Attendance
   * Create a new attendance with generated fields
   * @param data The data for the request.
   * @param data.requestBody
   * @returns StandardResponse_AttendanceResponse_ Attendance created successfully
   * @throws ApiError
   */
  public static createAttendanceApiV1AttendancesPost(
    data: CreateAttendanceApiV1AttendancesPostData,
  ): CancelablePromise<CreateAttendanceApiV1AttendancesPostResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/attendances/",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * List Attendances
   * Get a paginated list of attendances
   * @param data The data for the request.
   * @param data.skip Number of attendances to skip
   * @param data.limit Maximum number of attendances to return
   * @param data.createdBy Filter by creator user ID
   * @param data.search Search across available text fields
   * @param data.createdAfter Return attendances created after this timestamp
   * @param data.createdBefore Return attendances created before this timestamp
   * @param data.updatedAfter Return attendances updated after this timestamp
   * @param data.updatedBefore Return attendances updated before this timestamp
   * @param data.studentId Filter by specific student
   * @param data.classTemplateId Filter by class template
   * @param data.sessionId Filter by academic session
   * @param data.status Filter by attendance status
   * @param data.classDateFrom Filter class date from (inclusive)
   * @param data.classDateTo Filter class date to (inclusive)
   * @param data.sortBy Field to sort by
   * @param data.sortOrder Sort direction (ascending or descending)
   * @returns StandardResponse_AttendanceListResponse_ Attendances retrieved successfully
   * @throws ApiError
   */
  public static readAttendancesApiV1AttendancesGet(
    data: ReadAttendancesApiV1AttendancesGetData = {},
  ): CancelablePromise<ReadAttendancesApiV1AttendancesGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/attendances/",
      query: {
        skip: data.skip,
        limit: data.limit,
        created_by: data.createdBy,
        search: data.search,
        created_after: data.createdAfter,
        created_before: data.createdBefore,
        updated_after: data.updatedAfter,
        updated_before: data.updatedBefore,
        student_id: data.studentId,
        class_template_id: data.classTemplateId,
        session_id: data.sessionId,
        status: data.status,
        class_date_from: data.classDateFrom,
        class_date_to: data.classDateTo,
        sort_by: data.sortBy,
        sort_order: data.sortOrder,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Get Attendance
   * Get a specific attendance by ID
   * @param data The data for the request.
   * @param data.attendanceId
   * @returns StandardResponse_AttendanceResponse_ Attendance created successfully
   * @throws ApiError
   */
  public static readAttendanceApiV1AttendancesAttendanceIdGet(
    data: ReadAttendanceApiV1AttendancesAttendanceIdGetData,
  ): CancelablePromise<ReadAttendanceApiV1AttendancesAttendanceIdGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/attendances/{attendance_id}",
      path: {
        attendance_id: data.attendanceId,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Update Attendance
   * Update an existing attendance
   * @param data The data for the request.
   * @param data.attendanceId
   * @param data.requestBody
   * @returns StandardResponse_AttendanceResponse_ Attendance updated successfully
   * @throws ApiError
   */
  public static updateAttendanceApiV1AttendancesAttendanceIdPut(
    data: UpdateAttendanceApiV1AttendancesAttendanceIdPutData,
  ): CancelablePromise<UpdateAttendanceApiV1AttendancesAttendanceIdPutResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/attendances/{attendance_id}",
      path: {
        attendance_id: data.attendanceId,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Delete Attendance
   * Delete a attendance
   * @param data The data for the request.
   * @param data.attendanceId
   * @returns StandardResponse_NoneType_ Attendance deleted successfully
   * @throws ApiError
   */
  public static deleteAttendanceApiV1AttendancesAttendanceIdDelete(
    data: DeleteAttendanceApiV1AttendancesAttendanceIdDeleteData,
  ): CancelablePromise<DeleteAttendanceApiV1AttendancesAttendanceIdDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v1/attendances/{attendance_id}",
      path: {
        attendance_id: data.attendanceId,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }
}

export class AuthenticationService {
  /**
   * Register
   * Register a new user with email and password.
   *
   * Password requirements:
   * - Minimum 12 characters
   * - At least one uppercase letter
   * - At least one lowercase letter
   * - At least one number
   * - At least one special character
   * @param data The data for the request.
   * @param data.requestBody
   * @returns StandardResponse_UserResponse_ Successful Response
   * @throws ApiError
   */
  public static registerApiV1AuthRegisterPost(
    data: RegisterApiV1AuthRegisterPostData,
  ): CancelablePromise<RegisterApiV1AuthRegisterPostResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/auth/register",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        409: "Resource conflict",
        422: "Validation error",
      },
    })
  }

  /**
   * Login
   * OAuth2 compatible login endpoint (RFC 6749 Section 4.3.3).
   *
   *
   * **⚠️ OAuth2 Compliance Exception**
   *
   * This endpoint returns a raw OAuth2 Token response per [RFC 6749 Section 5.1](https://tools.ietf.org/html/rfc6749#section-5.1),
   * NOT wrapped in the standard `ApiResponse` format. This ensures compatibility with OAuth2 clients and libraries.
   *
   * All other authentication endpoints use the standard `ApiResponse` wrapper for consistency.
   *
   *
   * **Request Format:**
   * - Username field should contain email address
   * - Password field contains user password
   * - Follows OAuth2 password grant flow per RFC 6749 Section 4.3
   *
   * **Response Format:**
   * - Returns access token in response body per RFC 6749 Section 5.1
   * - Sets refresh token in httpOnly cookie for enhanced security
   * - Includes token_type="bearer" and expires_in per RFC specification
   *
   * **Security Features:**
   * - Rate limiting: 5 attempts per minute
   * - Failed login attempts are logged with IP/User-Agent
   * - Refresh token rotation with family tracking
   * @param data The data for the request.
   * @param data.formData
   * @returns Token Login successful
   * @throws ApiError
   */
  public static loginApiV1AuthLoginPost(
    data: LoginApiV1AuthLoginPostData,
  ): CancelablePromise<LoginApiV1AuthLoginPostResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/auth/login",
      formData: data.formData,
      mediaType: "application/x-www-form-urlencoded",
      errors: {
        401: "Authentication required",
        422: "Validation error",
      },
    })
  }

  /**
   * Refresh Token
   * Refresh access token using refresh token (RFC 6749 Section 6).
   *
   * PROTOCOL COMPLIANCE: Returns Token directly (not StandardResponse) to maintain
   * OAuth2 RFC 6749 compliance. Refresh token responses must use the same format
   * as authorization responses per RFC 6749 Section 5.1.
   *
   * Security Features:
   * - Implements refresh token rotation for enhanced security
   * - Accepts refresh token from httpOnly cookie (preferred) or request body
   * - Detects token reuse and revokes entire token family
   * - Issues new refresh token with same family ID for tracking
   *
   * See ADR-003 for StandardResponse pattern exception details.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns Token Login successful
   * @throws ApiError
   */
  public static refreshTokenApiV1AuthRefreshPost(
    data: RefreshTokenApiV1AuthRefreshPostData = {},
  ): CancelablePromise<RefreshTokenApiV1AuthRefreshPostResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/auth/refresh",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Authentication required",
        422: "Validation error",
      },
    })
  }

  /**
   * Request Password Reset
   * Request password reset email.
   *
   * Always returns success to prevent email enumeration.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns StandardResponse_NoneType_ Successful Response
   * @throws ApiError
   */
  public static requestPasswordResetApiV1AuthPasswordResetPost(
    data: RequestPasswordResetApiV1AuthPasswordResetPostData,
  ): CancelablePromise<RequestPasswordResetApiV1AuthPasswordResetPostResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/auth/password/reset",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        422: "Validation error",
      },
    })
  }

  /**
   * Confirm Password Reset
   * Confirm password reset using a token issued via email.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns StandardResponse_NoneType_ Successful Response
   * @throws ApiError
   */
  public static confirmPasswordResetApiV1AuthPasswordResetConfirmPost(
    data: ConfirmPasswordResetApiV1AuthPasswordResetConfirmPostData,
  ): CancelablePromise<ConfirmPasswordResetApiV1AuthPasswordResetConfirmPostResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/auth/password/reset/confirm",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad request",
        422: "Validation error",
      },
    })
  }

  /**
   * Verify Email
   * Verify user's email address with token.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns StandardResponse_NoneType_ Successful Response
   * @throws ApiError
   */
  public static verifyEmailApiV1AuthVerifyEmailPost(
    data: VerifyEmailApiV1AuthVerifyEmailPostData,
  ): CancelablePromise<VerifyEmailApiV1AuthVerifyEmailPostResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/auth/verify-email",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        400: "Bad request",
        401: "Authentication required",
        422: "Validation error",
      },
    })
  }

  /**
   * Resend Verification Email
   * Resend email verification for specified email.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns StandardResponse_NoneType_ Successful Response
   * @throws ApiError
   */
  public static resendVerificationEmailApiV1AuthResendVerificationPost(
    data: ResendVerificationEmailApiV1AuthResendVerificationPostData,
  ): CancelablePromise<ResendVerificationEmailApiV1AuthResendVerificationPostResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/auth/resend-verification",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        422: "Validation error",
      },
    })
  }

  /**
   * Check Password Strength
   * Check password strength and provide detailed feedback.
   *
   * This endpoint provides real-time password strength validation
   * without requiring authentication. Useful for registration forms
   * and password change interfaces.
   *
   * Security features:
   * - Rate limited to prevent brute force attempts
   * - No password storage or logging
   * - Comprehensive validation rules
   * - Strength scoring algorithm
   * @param data The data for the request.
   * @param data.requestBody
   * @returns StandardResponse_PasswordStrengthResponse_ Successful Response
   * @throws ApiError
   */
  public static checkPasswordStrengthApiV1AuthPasswordCheckStrengthPost(
    data: CheckPasswordStrengthApiV1AuthPasswordCheckStrengthPostData,
  ): CancelablePromise<CheckPasswordStrengthApiV1AuthPasswordCheckStrengthPostResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/auth/password/check-strength",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        422: "Validation error",
      },
    })
  }

  /**
   * Logout
   * Logout current user.
   *
   * Clears refresh token cookie and CSRF token cookie.
   * @returns StandardResponse_NoneType_ Successful Response
   * @throws ApiError
   */
  public static logoutApiV1AuthLogoutPost(): CancelablePromise<LogoutApiV1AuthLogoutPostResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/auth/logout",
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Get Current User
   * Get current user information with permissions.
   * @returns StandardResponse_UserWithPermissionsResponse_ Successful Response
   * @throws ApiError
   */
  public static getCurrentUserApiV1AuthMeGet(): CancelablePromise<GetCurrentUserApiV1AuthMeGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/auth/me",
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }
}

export class ClassSessionsService {
  /**
   * Create ClassSession
   * Create a new classSession with generated fields
   * @param data The data for the request.
   * @param data.requestBody
   * @returns StandardResponse_ClassSessionResponse_ ClassSession created successfully
   * @throws ApiError
   */
  public static createClassSessionApiV1ClassSessionsPost(
    data: CreateClassSessionApiV1ClassSessionsPostData,
  ): CancelablePromise<CreateClassSessionApiV1ClassSessionsPostResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/class-sessions/",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * List ClassSessions
   * Get a paginated list of classSessions
   * @param data The data for the request.
   * @param data.skip Number of classSessions to skip
   * @param data.limit Maximum number of classSessions to return
   * @param data.createdBy Filter by creator user ID
   * @param data.search Search across available text fields
   * @param data.createdAfter Return classSessions created after this timestamp
   * @param data.createdBefore Return classSessions created before this timestamp
   * @param data.updatedAfter Return classSessions updated after this timestamp
   * @param data.updatedBefore Return classSessions updated before this timestamp
   * @param data.classTemplateId Filter by class template
   * @param data.sessionId Filter by academic session
   * @param data.instructorId Filter by instructor
   * @param data.status Filter by session status
   * @param data.sessionDateFrom Filter session date from (inclusive)
   * @param data.sessionDateTo Filter session date to (inclusive)
   * @param data.sortBy Field to sort by
   * @param data.sortOrder Sort direction (ascending or descending)
   * @returns StandardResponse_ClassSessionListResponse_ ClassSessions retrieved successfully
   * @throws ApiError
   */
  public static readClassSessionsApiV1ClassSessionsGet(
    data: ReadClassSessionsApiV1ClassSessionsGetData = {},
  ): CancelablePromise<ReadClassSessionsApiV1ClassSessionsGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/class-sessions/",
      query: {
        skip: data.skip,
        limit: data.limit,
        created_by: data.createdBy,
        search: data.search,
        created_after: data.createdAfter,
        created_before: data.createdBefore,
        updated_after: data.updatedAfter,
        updated_before: data.updatedBefore,
        class_template_id: data.classTemplateId,
        session_id: data.sessionId,
        instructor_id: data.instructorId,
        status: data.status,
        session_date_from: data.sessionDateFrom,
        session_date_to: data.sessionDateTo,
        sort_by: data.sortBy,
        sort_order: data.sortOrder,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Get ClassSession
   * Get a specific classSession by ID
   * @param data The data for the request.
   * @param data.classSessionId
   * @returns StandardResponse_ClassSessionResponse_ ClassSession created successfully
   * @throws ApiError
   */
  public static readClassSessionApiV1ClassSessionsClassSessionIdGet(
    data: ReadClassSessionApiV1ClassSessionsClassSessionIdGetData,
  ): CancelablePromise<ReadClassSessionApiV1ClassSessionsClassSessionIdGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/class-sessions/{class_session_id}",
      path: {
        class_session_id: data.classSessionId,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Update ClassSession
   * Update an existing classSession
   * @param data The data for the request.
   * @param data.classSessionId
   * @param data.requestBody
   * @returns StandardResponse_ClassSessionResponse_ ClassSession updated successfully
   * @throws ApiError
   */
  public static updateClassSessionApiV1ClassSessionsClassSessionIdPut(
    data: UpdateClassSessionApiV1ClassSessionsClassSessionIdPutData,
  ): CancelablePromise<UpdateClassSessionApiV1ClassSessionsClassSessionIdPutResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/class-sessions/{class_session_id}",
      path: {
        class_session_id: data.classSessionId,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Delete ClassSession
   * Delete a classSession
   * @param data The data for the request.
   * @param data.classSessionId
   * @returns StandardResponse_NoneType_ ClassSession deleted successfully
   * @throws ApiError
   */
  public static deleteClassSessionApiV1ClassSessionsClassSessionIdDelete(
    data: DeleteClassSessionApiV1ClassSessionsClassSessionIdDeleteData,
  ): CancelablePromise<DeleteClassSessionApiV1ClassSessionsClassSessionIdDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v1/class-sessions/{class_session_id}",
      path: {
        class_session_id: data.classSessionId,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Get Future Class Sessions Count
   * Get the count of future class sessions for a class template and session (for pro-rating calculations)
   * @param data The data for the request.
   * @param data.classTemplateId Class template ID
   * @param data.sessionId Session ID
   * @returns StandardResponse_dict_str__Any__ Future sessions count returned successfully
   * @throws ApiError
   */
  public static getFutureClassSessionsCountApiV1ClassSessionsFutureCountGet(
    data: GetFutureClassSessionsCountApiV1ClassSessionsFutureCountGetData,
  ): CancelablePromise<GetFutureClassSessionsCountApiV1ClassSessionsFutureCountGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/class-sessions/future-count",
      query: {
        class_template_id: data.classTemplateId,
        session_id: data.sessionId,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }
}

export class ClassTemplatesService {
  /**
   * Create ClassTemplate
   * Create a new classTemplate with generated fields
   * @param data The data for the request.
   * @param data.requestBody
   * @returns StandardResponse_ClassTemplateResponse_ ClassTemplate created successfully
   * @throws ApiError
   */
  public static createClassTemplateApiV1ClassTemplatesPost(
    data: CreateClassTemplateApiV1ClassTemplatesPostData,
  ): CancelablePromise<CreateClassTemplateApiV1ClassTemplatesPostResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/class-templates/",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * List ClassTemplates
   * Get a paginated list of classTemplates
   * @param data The data for the request.
   * @param data.skip Number of classTemplates to skip
   * @param data.limit Maximum number of classTemplates to return
   * @param data.createdBy Filter by creator user ID
   * @param data.search Search across available text fields
   * @param data.createdAfter Return classTemplates created after this timestamp
   * @param data.createdBefore Return classTemplates created before this timestamp
   * @param data.updatedAfter Return classTemplates updated after this timestamp
   * @param data.updatedBefore Return classTemplates updated before this timestamp
   * @param data.sortBy Field to sort by
   * @param data.sortOrder Sort direction (ascending or descending)
   * @returns StandardResponse_ClassTemplateListResponse_ ClassTemplates retrieved successfully
   * @throws ApiError
   */
  public static readClassTemplatesApiV1ClassTemplatesGet(
    data: ReadClassTemplatesApiV1ClassTemplatesGetData = {},
  ): CancelablePromise<ReadClassTemplatesApiV1ClassTemplatesGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/class-templates/",
      query: {
        skip: data.skip,
        limit: data.limit,
        created_by: data.createdBy,
        search: data.search,
        swim_level: data.swimLevel,
        day_of_week: data.dayOfWeek,
        session_id: data.sessionId,
        time_of_day: data.timeOfDay,
        created_after: data.createdAfter,
        created_before: data.createdBefore,
        updated_after: data.updatedAfter,
        updated_before: data.updatedBefore,
        sort_by: data.sortBy,
        sort_order: data.sortOrder,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Get ClassTemplate
   * Get a specific classTemplate by ID
   * @param data The data for the request.
   * @param data.classTemplateId
   * @returns StandardResponse_ClassTemplateResponse_ ClassTemplate created successfully
   * @throws ApiError
   */
  public static readClassTemplateApiV1ClassTemplatesClassTemplateIdGet(
    data: ReadClassTemplateApiV1ClassTemplatesClassTemplateIdGetData,
  ): CancelablePromise<ReadClassTemplateApiV1ClassTemplatesClassTemplateIdGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/class-templates/{class_template_id}",
      path: {
        class_template_id: data.classTemplateId,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Update ClassTemplate
   * Update an existing classTemplate
   * @param data The data for the request.
   * @param data.classTemplateId
   * @param data.requestBody
   * @returns StandardResponse_ClassTemplateResponse_ ClassTemplate updated successfully
   * @throws ApiError
   */
  public static updateClassTemplateApiV1ClassTemplatesClassTemplateIdPut(
    data: UpdateClassTemplateApiV1ClassTemplatesClassTemplateIdPutData,
  ): CancelablePromise<UpdateClassTemplateApiV1ClassTemplatesClassTemplateIdPutResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/class-templates/{class_template_id}",
      path: {
        class_template_id: data.classTemplateId,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Delete ClassTemplate
   * Delete a classTemplate
   * @param data The data for the request.
   * @param data.classTemplateId
   * @returns StandardResponse_NoneType_ ClassTemplate deleted successfully
   * @throws ApiError
   */
  public static deleteClassTemplateApiV1ClassTemplatesClassTemplateIdDelete(
    data: DeleteClassTemplateApiV1ClassTemplatesClassTemplateIdDeleteData,
  ): CancelablePromise<DeleteClassTemplateApiV1ClassTemplatesClassTemplateIdDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v1/class-templates/{class_template_id}",
      path: {
        class_template_id: data.classTemplateId,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Generate Class Meetings
   * Generate class meetings for a published class template within a specific session
   * @param data The data for the request.
   * @param data.classTemplateId
   * @param data.sessionId Session ID to generate meetings for
   * @returns StandardResponse_dict_str__Any__ Successful Response
   * @throws ApiError
   */
  public static generateClassTemplateMeetingsApiV1ClassTemplatesClassTemplateIdGenerateMeetingsPost(
    data: GenerateClassTemplateMeetingsApiV1ClassTemplatesClassTemplateIdGenerateMeetingsPostData,
  ): CancelablePromise<GenerateClassTemplateMeetingsApiV1ClassTemplatesClassTemplateIdGenerateMeetingsPostResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/class-templates/{class_template_id}/generate_meetings",
      path: {
        class_template_id: data.classTemplateId,
      },
      query: {
        session_id: data.sessionId,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }
}

export class CommunicationsService {
  /**
   * Send Bulk Email
   * Send email to multiple parents based on selection criteria
   * @param data The data for the request.
   * @param data.requestBody
   * @returns StandardResponse_BulkEmailResponse_ Successful Response
   * @throws ApiError
   */
  public static sendBulkEmailApiV1CommunicationsBulkEmailPost(
    data: SendBulkEmailApiV1CommunicationsBulkEmailPostData,
  ): CancelablePromise<SendBulkEmailApiV1CommunicationsBulkEmailPostResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/communications/bulk-email",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }
}

export class EnrollmentsService {
  /**
   * Create Enrollment
   * Create a new enrollment with generated fields
   * @param data The data for the request.
   * @param data.requestBody
   * @returns StandardResponse_EnrollmentResponse_ Enrollment created successfully
   * @throws ApiError
   */
  public static createEnrollmentApiV1EnrollmentsPost(
    data: CreateEnrollmentApiV1EnrollmentsPostData,
  ): CancelablePromise<CreateEnrollmentApiV1EnrollmentsPostResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/enrollments/",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * List Enrollments
   * Get a paginated list of enrollments
   * @param data The data for the request.
   * @param data.skip Number of enrollments to skip
   * @param data.limit Maximum number of enrollments to return
   * @param data.createdBy Filter by creator user ID
   * @param data.search Search across available text fields
   * @param data.createdAfter Return enrollments created after this timestamp
   * @param data.createdBefore Return enrollments created before this timestamp
   * @param data.updatedAfter Return enrollments updated after this timestamp
   * @param data.updatedBefore Return enrollments updated before this timestamp
   * @param data.studentId Filter by specific student
   * @param data.classTemplateId Filter by class template
   * @param data.sessionId Filter by academic session
   * @param data.status Filter by enrollment status
   * @param data.sortBy Field to sort by
   * @param data.sortOrder Sort direction (ascending or descending)
   * @returns StandardResponse_EnrollmentListResponse_ Enrollments retrieved successfully
   * @throws ApiError
   */
  public static readEnrollmentsApiV1EnrollmentsGet(
    data: ReadEnrollmentsApiV1EnrollmentsGetData = {},
  ): CancelablePromise<ReadEnrollmentsApiV1EnrollmentsGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/enrollments/",
      query: {
        skip: data.skip,
        limit: data.limit,
        created_by: data.createdBy,
        search: data.search,
        created_after: data.createdAfter,
        created_before: data.createdBefore,
        updated_after: data.updatedAfter,
        updated_before: data.updatedBefore,
        student_id: data.studentId,
        class_template_id: data.classTemplateId,
        session_id: data.sessionId,
        status: data.status,
        sort_by: data.sortBy,
        sort_order: data.sortOrder,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Get Enrollment
   * Get a specific enrollment by ID
   * @param data The data for the request.
   * @param data.enrollmentId
   * @returns StandardResponse_EnrollmentResponse_ Enrollment created successfully
   * @throws ApiError
   */
  public static readEnrollmentApiV1EnrollmentsEnrollmentIdGet(
    data: ReadEnrollmentApiV1EnrollmentsEnrollmentIdGetData,
  ): CancelablePromise<ReadEnrollmentApiV1EnrollmentsEnrollmentIdGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/enrollments/{enrollment_id}",
      path: {
        enrollment_id: data.enrollmentId,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Update Enrollment
   * Update an existing enrollment
   * @param data The data for the request.
   * @param data.enrollmentId
   * @param data.requestBody
   * @returns StandardResponse_EnrollmentResponse_ Enrollment updated successfully
   * @throws ApiError
   */
  public static updateEnrollmentApiV1EnrollmentsEnrollmentIdPut(
    data: UpdateEnrollmentApiV1EnrollmentsEnrollmentIdPutData,
  ): CancelablePromise<UpdateEnrollmentApiV1EnrollmentsEnrollmentIdPutResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/enrollments/{enrollment_id}",
      path: {
        enrollment_id: data.enrollmentId,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Delete Enrollment
   * Delete a enrollment
   * @param data The data for the request.
   * @param data.enrollmentId
   * @returns StandardResponse_NoneType_ Enrollment deleted successfully
   * @throws ApiError
   */
  public static deleteEnrollmentApiV1EnrollmentsEnrollmentIdDelete(
    data: DeleteEnrollmentApiV1EnrollmentsEnrollmentIdDeleteData,
  ): CancelablePromise<DeleteEnrollmentApiV1EnrollmentsEnrollmentIdDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v1/enrollments/{enrollment_id}",
      path: {
        enrollment_id: data.enrollmentId,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }
}

export class FilesService {
  /**
   * Upload File
   * Upload a file.
   *
   * Supported upload types:
   * - avatar: User profile pictures
   * - attachment: General file attachments
   * - document: Document files
   * @param data The data for the request.
   * @param data.formData
   * @returns StandardResponse_FileUploadResponse_ File uploaded successfully
   * @throws ApiError
   */
  public static uploadFileApiV1FilesUploadPost(
    data: UploadFileApiV1FilesUploadPostData,
  ): CancelablePromise<UploadFileApiV1FilesUploadPostResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/files/upload",
      formData: data.formData,
      mediaType: "multipart/form-data",
      errors: {
        400: "Bad request - Error parsing multipart form data",
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * List Files
   * List files with user-based filtering.
   *
   * Regular users see only their own files.
   * Admin users (with system:admin scope) see all files.
   * @param data The data for the request.
   * @param data.uploadType
   * @param data.page
   * @param data.perPage
   * @returns StandardResponse_FileListResponse_ Successful Response
   * @throws ApiError
   */
  public static listFilesApiV1FilesGet(
    data: ListFilesApiV1FilesGetData = {},
  ): CancelablePromise<ListFilesApiV1FilesGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/files/",
      query: {
        upload_type: data.uploadType,
        page: data.page,
        per_page: data.perPage,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Get File Info
   * Get file information.
   * @param data The data for the request.
   * @param data.fileId
   * @returns StandardResponse_FileResponse_ Successful Response
   * @throws ApiError
   */
  public static getFileInfoApiV1FilesFileIdGet(
    data: GetFileInfoApiV1FilesFileIdGetData,
  ): CancelablePromise<GetFileInfoApiV1FilesFileIdGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/files/{file_id}",
      path: {
        file_id: data.fileId,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Delete File
   * Delete a file.
   * @param data The data for the request.
   * @param data.fileId
   * @returns StandardResponse_dict_ Successful Response
   * @throws ApiError
   */
  public static deleteFileApiV1FilesFileIdDelete(
    data: DeleteFileApiV1FilesFileIdDeleteData,
  ): CancelablePromise<DeleteFileApiV1FilesFileIdDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v1/files/{file_id}",
      path: {
        file_id: data.fileId,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Download File
   * Download a file.
   *
   * Note: This endpoint returns binary data (FastAPIFileResponse) and is a valid
   * exception to the StandardResponse pattern. Binary file downloads cannot be
   * wrapped in JSON responses as they need to preserve the original file format
   * and enable proper browser handling (content-disposition, mime types, etc.).
   * @param data The data for the request.
   * @param data.fileId
   * @returns unknown Successful Response
   * @throws ApiError
   */
  public static downloadFileApiV1FilesFileIdDownloadGet(
    data: DownloadFileApiV1FilesFileIdDownloadGetData,
  ): CancelablePromise<DownloadFileApiV1FilesFileIdDownloadGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/files/{file_id}/download",
      path: {
        file_id: data.fileId,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Set File Public
   * Set file public/private status.
   * @param data The data for the request.
   * @param data.fileId
   * @param data.isPublic
   * @returns StandardResponse_FileResponse_ Successful Response
   * @throws ApiError
   */
  public static setFilePublicApiV1FilesFileIdSetPublicPost(
    data: SetFilePublicApiV1FilesFileIdSetPublicPostData,
  ): CancelablePromise<SetFilePublicApiV1FilesFileIdSetPublicPostResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/files/{file_id}/set-public",
      path: {
        file_id: data.fileId,
      },
      query: {
        is_public: data.isPublic,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }
}

export class HealthService {
  /**
   * Health
   * Basic health check endpoint.
   * @returns StandardResponse_dict_str__Any__ Detailed health status retrieved successfully
   * @throws ApiError
   */
  public static healthGet(): CancelablePromise<HealthHealthGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/health",
      errors: {
        422: "Validation error",
      },
    })
  }

  /**
   * Liveness
   * Kubernetes liveness probe.
   *
   * Returns 200 if the service is alive.
   * @returns StandardResponse_dict_str__str__ Successful Response
   * @throws ApiError
   */
  public static livenessHealthLiveGet(): CancelablePromise<LivenessHealthLiveGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/health/live",
      errors: {
        422: "Validation error",
      },
    })
  }

  /**
   * Readiness
   * Kubernetes readiness probe.
   *
   * Checks if the service is ready to handle requests.
   * @returns StandardResponse_dict_str__Any__ Successful Response
   * @throws ApiError
   */
  public static readinessHealthReadyGet(): CancelablePromise<ReadinessHealthReadyGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/health/ready",
      errors: {
        422: "Validation error",
      },
    })
  }

  /**
   * Performance Metrics
   * Get query performance metrics.
   *
   * Returns performance statistics including slow queries, query counts, and timing data.
   * @returns StandardResponse_dict_str__Any__ Successful Response
   * @throws ApiError
   */
  public static performanceMetricsHealthPerformanceGet(): CancelablePromise<PerformanceMetricsHealthPerformanceGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/health/performance",
      errors: {
        422: "Validation error",
      },
    })
  }
}

export class HouseholdsService {
  /**
   * Get Own Household
   * Retrieve the household associated with the current user
   * @returns StandardResponse_HouseholdResponse_ Successful Response
   * @throws ApiError
   */
  public static readHouseholdMeApiV1HouseholdsMeGet(): CancelablePromise<ReadHouseholdMeApiV1HouseholdsMeGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/households/me",
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Create Household
   * Create a new household with generated fields
   * @param data The data for the request.
   * @param data.requestBody
   * @returns StandardResponse_HouseholdResponse_ Household created successfully
   * @throws ApiError
   */
  public static createHouseholdApiV1HouseholdsPost(
    data: CreateHouseholdApiV1HouseholdsPostData,
  ): CancelablePromise<CreateHouseholdApiV1HouseholdsPostResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/households/",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * List Households
   * Get a paginated list of households
   * @param data The data for the request.
   * @param data.skip Number of households to skip
   * @param data.limit Maximum number of households to return
   * @param data.createdBy Filter by creator user ID
   * @param data.search Search across available text fields
   * @param data.createdAfter Return households created after this timestamp
   * @param data.createdBefore Return households created before this timestamp
   * @param data.updatedAfter Return households updated after this timestamp
   * @param data.updatedBefore Return households updated before this timestamp
   * @param data.sortBy Field to sort by
   * @param data.sortOrder Sort direction (ascending or descending)
   * @returns StandardResponse_HouseholdListResponse_ Households retrieved successfully
   * @throws ApiError
   */
  public static readHouseholdsApiV1HouseholdsGet(
    data: ReadHouseholdsApiV1HouseholdsGetData = {},
  ): CancelablePromise<ReadHouseholdsApiV1HouseholdsGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/households/",
      query: {
        skip: data.skip,
        limit: data.limit,
        created_by: data.createdBy,
        search: data.search,
        created_after: data.createdAfter,
        created_before: data.createdBefore,
        updated_after: data.updatedAfter,
        updated_before: data.updatedBefore,
        sort_by: data.sortBy,
        sort_order: data.sortOrder,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Get Household
   * Get a specific household by ID
   * @param data The data for the request.
   * @param data.householdId
   * @returns StandardResponse_HouseholdResponse_ Household created successfully
   * @throws ApiError
   */
  public static readHouseholdApiV1HouseholdsHouseholdIdGet(
    data: ReadHouseholdApiV1HouseholdsHouseholdIdGetData,
  ): CancelablePromise<ReadHouseholdApiV1HouseholdsHouseholdIdGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/households/{household_id}",
      path: {
        household_id: data.householdId,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Update Household
   * Update an existing household
   * @param data The data for the request.
   * @param data.householdId
   * @param data.requestBody
   * @returns StandardResponse_HouseholdResponse_ Household updated successfully
   * @throws ApiError
   */
  public static updateHouseholdApiV1HouseholdsHouseholdIdPut(
    data: UpdateHouseholdApiV1HouseholdsHouseholdIdPutData,
  ): CancelablePromise<UpdateHouseholdApiV1HouseholdsHouseholdIdPutResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/households/{household_id}",
      path: {
        household_id: data.householdId,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Delete Household
   * Delete a household
   * @param data The data for the request.
   * @param data.householdId
   * @returns StandardResponse_NoneType_ Household deleted successfully
   * @throws ApiError
   */
  public static deleteHouseholdApiV1HouseholdsHouseholdIdDelete(
    data: DeleteHouseholdApiV1HouseholdsHouseholdIdDeleteData,
  ): CancelablePromise<DeleteHouseholdApiV1HouseholdsHouseholdIdDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v1/households/{household_id}",
      path: {
        household_id: data.householdId,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }
}

export class InvoicesService {
  /**
   * List Invoices
   * List all invoices with enriched data (household, student info).
   *
   * Requires invoices:read or invoices:read_own permission.
   * Staff see all invoices, parents see only their own.
   * @param data The data for the request.
   * @param data.skip
   * @param data.limit
   * @param data.paymentStatus Filter by payment status
   * @returns unknown Successful Response
   * @throws ApiError
   */
  public static listInvoicesApiV1InvoicesGet(
    data: ListInvoicesApiV1InvoicesGetData = {},
  ): CancelablePromise<ListInvoicesApiV1InvoicesGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/invoices/",
      query: {
        skip: data.skip,
        limit: data.limit,
        payment_status: data.paymentStatus,
      },
      errors: {
        422: "Validation Error",
      },
    })
  }

  /**
   * Update Invoice
   * Update an invoice (primarily for recording payments).
   *
   * Requires invoices:update or invoices:update_payment_status permission.
   * @param data The data for the request.
   * @param data.invoiceId
   * @param data.requestBody
   * @returns unknown Successful Response
   * @throws ApiError
   */
  public static updateInvoiceApiV1InvoicesInvoiceIdPut(
    data: UpdateInvoiceApiV1InvoicesInvoiceIdPutData,
  ): CancelablePromise<UpdateInvoiceApiV1InvoicesInvoiceIdPutResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/invoices/{invoice_id}",
      path: {
        invoice_id: data.invoiceId,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        422: "Validation Error",
      },
    })
  }

  /**
   * Get Invoice
   * Get invoice by ID.
   *
   * Requires invoices:read or invoices:read_own permission.
   * @param data The data for the request.
   * @param data.invoiceId
   * @returns unknown Successful Response
   * @throws ApiError
   */
  public static getInvoiceApiV1InvoicesInvoiceIdGet(
    data: GetInvoiceApiV1InvoicesInvoiceIdGetData,
  ): CancelablePromise<GetInvoiceApiV1InvoicesInvoiceIdGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/invoices/{invoice_id}",
      path: {
        invoice_id: data.invoiceId,
      },
      errors: {
        422: "Validation Error",
      },
    })
  }
}

export class MonitoringService {
  /**
   * Record Web Vitals metrics
   * Receives a batch of Web Vitals metrics from the frontend and records them for observability dashboards.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns StandardResponse_dict_str__int__ Successful Response
   * @throws ApiError
   */
  public static recordWebVitalsApiV1MonitoringWebVitalsPost(
    data: RecordWebVitalsApiV1MonitoringWebVitalsPostData,
  ): CancelablePromise<RecordWebVitalsApiV1MonitoringWebVitalsPostResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/monitoring/web-vitals",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        422: "Validation error",
      },
    })
  }
}

export class ProfilesService {
  /**
   * Get Public Profile
   * Get public profile by username.
   *
   * Returns public profile information if the profile is set to public.
   * @param data The data for the request.
   * @param data.username
   * @returns StandardResponse_PublicProfileResponse_ Successful Response
   * @throws ApiError
   */
  public static getPublicProfileApiV1ProfilesUsernameGet(
    data: GetPublicProfileApiV1ProfilesUsernameGetData,
  ): CancelablePromise<GetPublicProfileApiV1ProfilesUsernameGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/profiles/{username}",
      path: {
        username: data.username,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Get Public Profile By Id
   * Get public profile by user ID.
   *
   * Returns public profile information if the profile is set to public.
   * @param data The data for the request.
   * @param data.userId
   * @returns StandardResponse_PublicProfileResponse_ Successful Response
   * @throws ApiError
   */
  public static getPublicProfileByIdApiV1ProfilesIdUserIdGet(
    data: GetPublicProfileByIdApiV1ProfilesIdUserIdGetData,
  ): CancelablePromise<GetPublicProfileByIdApiV1ProfilesIdUserIdGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/profiles/id/{user_id}",
      path: {
        user_id: data.userId,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }
}

export class SessionsService {
  /**
   * Create Session
   * Create a new session with generated fields
   * @param data The data for the request.
   * @param data.requestBody
   * @returns StandardResponse_SessionResponse_ Session created successfully
   * @throws ApiError
   */
  public static createSessionApiV1SessionsPost(
    data: CreateSessionApiV1SessionsPostData,
  ): CancelablePromise<CreateSessionApiV1SessionsPostResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/sessions/",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * List Sessions
   * Get a paginated list of sessions
   * @param data The data for the request.
   * @param data.skip Number of sessions to skip
   * @param data.limit Maximum number of sessions to return
   * @param data.createdBy Filter by creator user ID
   * @param data.search Search across available text fields
   * @param data.createdAfter Return sessions created after this timestamp
   * @param data.createdBefore Return sessions created before this timestamp
   * @param data.updatedAfter Return sessions updated after this timestamp
   * @param data.updatedBefore Return sessions updated before this timestamp
   * @param data.sortBy Field to sort by
   * @param data.sortOrder Sort direction (ascending or descending)
   * @returns StandardResponse_SessionListResponse_ Sessions retrieved successfully
   * @throws ApiError
   */
  public static readSessionsApiV1SessionsGet(
    data: ReadSessionsApiV1SessionsGetData = {},
  ): CancelablePromise<ReadSessionsApiV1SessionsGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/sessions/",
      query: {
        skip: data.skip,
        limit: data.limit,
        created_by: data.createdBy,
        search: data.search,
        created_after: data.createdAfter,
        created_before: data.createdBefore,
        updated_after: data.updatedAfter,
        updated_before: data.updatedBefore,
        sort_by: data.sortBy,
        sort_order: data.sortOrder,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Get Session
   * Get a specific session by ID
   * @param data The data for the request.
   * @param data.sessionId
   * @returns StandardResponse_SessionResponse_ Session created successfully
   * @throws ApiError
   */
  public static readSessionApiV1SessionsSessionIdGet(
    data: ReadSessionApiV1SessionsSessionIdGetData,
  ): CancelablePromise<ReadSessionApiV1SessionsSessionIdGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/sessions/{session_id}",
      path: {
        session_id: data.sessionId,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Update Session
   * Update an existing session
   * @param data The data for the request.
   * @param data.sessionId
   * @param data.requestBody
   * @returns StandardResponse_SessionResponse_ Session updated successfully
   * @throws ApiError
   */
  public static updateSessionApiV1SessionsSessionIdPut(
    data: UpdateSessionApiV1SessionsSessionIdPutData,
  ): CancelablePromise<UpdateSessionApiV1SessionsSessionIdPutResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/sessions/{session_id}",
      path: {
        session_id: data.sessionId,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Delete Session
   * Delete a session
   * @param data The data for the request.
   * @param data.sessionId
   * @returns StandardResponse_NoneType_ Session deleted successfully
   * @throws ApiError
   */
  public static deleteSessionApiV1SessionsSessionIdDelete(
    data: DeleteSessionApiV1SessionsSessionIdDeleteData,
  ): CancelablePromise<DeleteSessionApiV1SessionsSessionIdDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v1/sessions/{session_id}",
      path: {
        session_id: data.sessionId,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }
}

export class StudentsService {
  /**
   * Create Student
   * Create a new student with generated fields
   * @param data The data for the request.
   * @param data.requestBody
   * @returns StandardResponse_StudentResponse_ Student created successfully
   * @throws ApiError
   */
  public static createStudentApiV1StudentsPost(
    data: CreateStudentApiV1StudentsPostData,
  ): CancelablePromise<CreateStudentApiV1StudentsPostResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/students/",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * List Students
   * Get a paginated list of students
   * @param data The data for the request.
   * @param data.skip Number of students to skip
   * @param data.limit Maximum number of students to return
   * @param data.createdBy Filter by creator user ID
   * @param data.search Search across available text fields
   * @param data.createdAfter Return students created after this timestamp
   * @param data.createdBefore Return students created before this timestamp
   * @param data.updatedAfter Return students updated after this timestamp
   * @param data.updatedBefore Return students updated before this timestamp
   * @param data.sortBy Field to sort by
   * @param data.sortOrder Sort direction (ascending or descending)
   * @returns StandardResponse_StudentListResponse_ Students retrieved successfully
   * @throws ApiError
   */
  public static readStudentsApiV1StudentsGet(
    data: ReadStudentsApiV1StudentsGetData = {},
  ): CancelablePromise<ReadStudentsApiV1StudentsGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/students/",
      query: {
        skip: data.skip,
        limit: data.limit,
        created_by: data.createdBy,
        search: data.search,
        created_after: data.createdAfter,
        created_before: data.createdBefore,
        updated_after: data.updatedAfter,
        updated_before: data.updatedBefore,
        sort_by: data.sortBy,
        sort_order: data.sortOrder,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Get Student
   * Get a specific student by ID
   * @param data The data for the request.
   * @param data.studentId
   * @returns StandardResponse_StudentResponse_ Student created successfully
   * @throws ApiError
   */
  public static readStudentApiV1StudentsStudentIdGet(
    data: ReadStudentApiV1StudentsStudentIdGetData,
  ): CancelablePromise<ReadStudentApiV1StudentsStudentIdGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/students/{student_id}",
      path: {
        student_id: data.studentId,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Update Student
   * Update an existing student
   * @param data The data for the request.
   * @param data.studentId
   * @param data.requestBody
   * @returns StandardResponse_StudentResponse_ Student updated successfully
   * @throws ApiError
   */
  public static updateStudentApiV1StudentsStudentIdPut(
    data: UpdateStudentApiV1StudentsStudentIdPutData,
  ): CancelablePromise<UpdateStudentApiV1StudentsStudentIdPutResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/students/{student_id}",
      path: {
        student_id: data.studentId,
      },
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Delete Student
   * Delete a student
   * @param data The data for the request.
   * @param data.studentId
   * @returns StandardResponse_NoneType_ Student deleted successfully
   * @throws ApiError
   */
  public static deleteStudentApiV1StudentsStudentIdDelete(
    data: DeleteStudentApiV1StudentsStudentIdDeleteData,
  ): CancelablePromise<DeleteStudentApiV1StudentsStudentIdDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v1/students/{student_id}",
      path: {
        student_id: data.studentId,
      },
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }
}

export class SystemService {
  /**
   * Get System Limits
   * Get current system limits and configuration.
   *
   * Returns current request size limits, rate limiting settings,
   * and other system-wide quotas for admin monitoring.
   *
   * This endpoint helps administrators understand the current
   * system configuration and limits in place.
   * @returns StandardResponse_SystemLimitsResponse_ Successful Response
   * @throws ApiError
   */
  public static getSystemLimitsApiV1SystemLimitsGet(): CancelablePromise<GetSystemLimitsApiV1SystemLimitsGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/system/limits",
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }
}

export class UsersService {
  /**
   * Get Current User
   * Get current user profile.
   *
   * Returns the profile information for the currently authenticated user.
   * @returns StandardResponse_UserResponse_ User profile retrieved successfully
   * @throws ApiError
   */
  public static getCurrentUserApiV1UsersMeGet(): CancelablePromise<GetCurrentUserApiV1UsersMeGetResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/v1/users/me",
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Update Current User
   * Update current user's profile (limited self-service).
   *
   * Users can only update their display name. Email changes are not allowed
   * since email is used for authentication. Admins should use admin endpoints
   * for full user management including email changes.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns StandardResponse_UserResponse_ Successful Response
   * @throws ApiError
   */
  public static updateCurrentUserApiV1UsersMePut(
    data: UpdateCurrentUserApiV1UsersMePutData,
  ): CancelablePromise<UpdateCurrentUserApiV1UsersMePutResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/users/me",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Deactivate Current User
   * Deactivate current user's account (self-service).
   *
   * Users can deactivate their own account. Account can be reactivated by admins.
   * Includes safety check to prevent deactivation of the last admin user.
   * @returns StandardResponse_NoneType_ Successful Response
   * @throws ApiError
   */
  public static deactivateCurrentUserApiV1UsersMeDeactivatePost(): CancelablePromise<DeactivateCurrentUserApiV1UsersMeDeactivatePostResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/users/me/deactivate",
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Change Password
   * Change the current user's password.
   *
   * Requires the current password for verification.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns StandardResponse_NoneType_ Successful Response
   * @throws ApiError
   */
  public static changePasswordApiV1UsersMeChangePasswordPost(
    data: ChangePasswordApiV1UsersMeChangePasswordPostData,
  ): CancelablePromise<ChangePasswordApiV1UsersMeChangePasswordPostResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/users/me/change-password",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Upload Avatar
   * Upload or update user avatar.
   *
   * Supported formats: JPEG, PNG, WebP
   * Max size: 5MB
   * @param data The data for the request.
   * @param data.formData
   * @returns StandardResponse_dict_ Successful Response
   * @throws ApiError
   */
  public static uploadAvatarApiV1UsersMeAvatarPost(
    data: UploadAvatarApiV1UsersMeAvatarPostData,
  ): CancelablePromise<UploadAvatarApiV1UsersMeAvatarPostResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/users/me/avatar",
      formData: data.formData,
      mediaType: "multipart/form-data",
      errors: {
        400: "Bad request - Error parsing multipart form data",
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Delete Avatar
   * Remove user avatar.
   * @returns StandardResponse_NoneType_ Successful Response
   * @throws ApiError
   */
  public static deleteAvatarApiV1UsersMeAvatarDelete(): CancelablePromise<DeleteAvatarApiV1UsersMeAvatarDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v1/users/me/avatar",
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Upload Cover Photo
   * Upload or update user cover photo.
   *
   * Supported formats: JPEG, PNG, WebP
   * Max size: 10MB
   * @param data The data for the request.
   * @param data.formData
   * @returns StandardResponse_dict_ Successful Response
   * @throws ApiError
   */
  public static uploadCoverPhotoApiV1UsersMeCoverPhotoPost(
    data: UploadCoverPhotoApiV1UsersMeCoverPhotoPostData,
  ): CancelablePromise<UploadCoverPhotoApiV1UsersMeCoverPhotoPostResponse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/v1/users/me/cover-photo",
      formData: data.formData,
      mediaType: "multipart/form-data",
      errors: {
        400: "Bad request - Error parsing multipart form data",
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Delete Cover Photo
   * Remove user cover photo.
   * @returns StandardResponse_NoneType_ Successful Response
   * @throws ApiError
   */
  public static deleteCoverPhotoApiV1UsersMeCoverPhotoDelete(): CancelablePromise<DeleteCoverPhotoApiV1UsersMeCoverPhotoDeleteResponse> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/api/v1/users/me/cover-photo",
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }

  /**
   * Update Profile
   * Update user profile social links and skills.
   * @param data The data for the request.
   * @param data.requestBody
   * @returns StandardResponse_UserResponse_ Successful Response
   * @throws ApiError
   */
  public static updateProfileApiV1UsersMeProfilePut(
    data: UpdateProfileApiV1UsersMeProfilePutData,
  ): CancelablePromise<UpdateProfileApiV1UsersMeProfilePutResponse> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/api/v1/users/me/profile",
      body: data.requestBody,
      mediaType: "application/json",
      errors: {
        401: "Authentication required",
        403: "Insufficient permissions",
        404: "Resource not found",
        422: "Validation error",
      },
    })
  }
}
